import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import RecommendedCollectionsTable from './RecommendedCollectionsTable';

export default class RecommendedCollectionsSection extends PureComponent {
    static propTypes = {
        recommendedCollectionOptions: PropTypes.arrayOf(PropTypes.object),
        loggedInUser: PropTypes.object,
        currentValues: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedRecommendedCollection: {},
            selectedAssignedCollection: {}
        };
    }

    /**
     *
     * @param {Object} selectedCollection
     * @param {String} stateKey
     */
    handleRecommendedCollectionChange = (selectedCollection, stateKey) => {
        this.setState({ [stateKey]: selectedCollection });
    };

    /**
     *
     * @param {Object} fields
     * @param {Object} collection
     * @param {String} code
     * @returns {*}
     */
    handleAddRecommendedCollection = (fields, collection = {}, code) => {
        const { loggedInUser } = this.props;

        const stateKey = code === 'ASSIGNED' ? 'selectedAssignedCollection' : 'selectedRecommendedCollection';
        if (collection && collection._id) {
            fields.push({
                id: collection._id,
                name: collection.name,
                code,
                recommendedDateTime: new Date(),
                recommendedBy: {
                    userProfileId: loggedInUser._id,
                }
            });

            this.setState({ [stateKey]: {} });
        }
    };

    render() {
        const { recommendedCollectionOptions, currentValues } = this.props;
        const { selectedRecommendedCollection, selectedAssignedCollection } = this.state;
        return (
            <div className={'recommended-collections-section'}>
                <FieldArray
                    name={'recommendedCollections'}
                    selectedRecommendedCollection={selectedRecommendedCollection}
                    selectedAssignedCollection={selectedAssignedCollection}
                    recommendedCollectionOptions={recommendedCollectionOptions}
                    handleRecommendedCollectionChange={this.handleRecommendedCollectionChange}
                    handleAddRecommendedCollection={this.handleAddRecommendedCollection}
                    currentValues={currentValues}
                    component={RecommendedCollectionsTable}
                />
            </div>
        );
    }
}
